import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import env from "../../config/env";
import { useSelector } from "react-redux";
import CryptoJS from "crypto-js";

const SECRET_KEY = env.REACT_APP_ENCRYPTION_KEY;

export const fetchHolidayData = createAsyncThunk("fetchHolidayData", async (obj) => {

  const getHoliday = CryptoJS.SHA256("/getHoliday" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12); // Shorten for readability

  const role = CryptoJS.AES.encrypt(JSON.stringify(obj?.roleId), SECRET_KEY).toString();
  const encodedRole = encodeURIComponent(role); 

  const response = await fetch(`${env.backend_api_endpoint}/${getHoliday}?roleId=${encodedRole}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: obj?.token,
      },
    }
  );
  const resData = await response.json();

  if (resData?.encryptedData) {
    try {
      const bytes = CryptoJS.AES.decrypt(resData.encryptedData, SECRET_KEY);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      resData.encryptedData = JSON.parse(decrypted); // replace encrypted data with decrypted JSON
    } catch (err) {
      console.error("Decryption error:", err);
      resData.data = null; // fallback if decryption fails
    }
  }

  // Return the full response (status, message, and decrypted data)
  return resData;
}
);

const holidayDataSlice = createSlice({
  name: "getHoliday",
  initialState: {
    isLoading: false,
    data: null,
    isError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchHolidayData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchHolidayData.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchHolidayData.rejected, (state, action) => {
      state.isError = true;
    });
  },
});

export default holidayDataSlice.reducer;
